<template>
  <el-form
      ref="form"
      :style="{'height': '100%'}"
      :model="form">
    <gj-table
        :index="false"
        :loading="loading"
        name="purchaseChangeProductForm"
        border
        :show-overflow="false"
        adaptParent
        :data="form.items"
        :columns="columns">
      <template v-slot:sku="{row}">
        <div>
          <gj-text>{{row.productName | defaultShow}}</gj-text>
        </div>
        <div>{{row.sku | defaultShow}}</div>
        <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
      </template>
      <template v-slot:newOrderQuantity="{index, row}">
        <el-form-item
            :prop="`items.${index}.newOrderQuantity`"
            :rules="[
              $gjRequired('请输入新采购量'),
              $gjReRule(RE.pt0, '请输入大于等于0的整数'),
              $gjCustomRule(lessQuantityValidator(row.alreadyDeliveryQuantity), '需大于等于已交量'),
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.items[index].newOrderQuantity"
              @input="orderQuantityInput(index)"
              width="100px">
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:newIncludeTaxPrice="{index}">
        <el-form-item
            :prop="`items.${index}.newIncludeTaxPrice`"
            :rules="[
              $gjRequired('请输入新含税单价'),
              $gjReRule(RE.num(2), '请输入最多2位小数的整数')
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.items[index].newIncludeTaxPrice"
              @input="includeTaxPriceInput(index)"
              width="100%">
            <template #prepend>{{form.items[index].currencySymbol}}</template>
          </gj-input>
        </el-form-item>
      </template>
      <template v-slot:newAmount="{index}">
        {{form.items[index].newAmount | amount | defaultShow(currencySymbol)}}
      </template>
      <template v-slot:memo="{index}">
        <gj-input
            v-model="form.items[index].memo"
            width="100%">
        </gj-input>
      </template>
      <template #footer>
        <div v-gutter="20"
             class="default">
          <span>新产品种类数：{{totalProductNum}}</span>
          <span>新采购量合计：{{form.items | sum('newOrderQuantity')}}</span>
          <span>新总金额合计：{{form.items | sum('newAmount') | amount | defaultShow(currencySymbol)}}</span>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
  import {formRuleMixin} from "../../../../../../../minxins";
  import {isMeaningful, toFixed} from "../../../../../../../utils/common";
  import {ProductEnum} from "../../../../../../../utils/options";
  import {fastInboundPurchaseOrder} from "../../../../../../../api/purchase";

  export default {
    name: "app-purchase-change-product",
    mixins: [formRuleMixin],
    props: {
      form: {
        required: true
      },
      purchaseOrder: {
        required: true
      }
    },
    data() {
      return {
        loading: false,
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px', fixed: 'left'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px', fixed: 'left'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '80px', align: 'right'},
          {id: 'orderQuantity', header: '原采购量', field: 'orderQuantity', width: '80px', align: 'right'},
          {id: 'includeTaxPrice', header: '原含税单价', field: 'includeTaxPrice', prefix: 'currencySymbol', width: '100px', align: 'right'},
          {id: 'amount', header: '原金额', field: 'amount', prefix: 'currencySymbol', width: '100px', align: 'right'},
          {id: 'alreadyDeliveryQuantity', header: '已交量', field: 'alreadyDeliveryQuantity', width: '80px', align: 'right'},
          {id: 'noDeliveryQuantity', header: '未交量', field: 'noDeliveryQuantity', width: '80px', align: 'right'},
          {id: 'newOrderQuantity', header: '新采购量', field: 'slot:newOrderQuantity', required: true, width: '120px'},
          {id: 'newIncludeTaxPrice', header: '新含税单价', field: 'slot:newIncludeTaxPrice', required: true, width: '130px'},
          {id: 'newAmount', header: '新金额', field: 'slot:newAmount', width: '100px', align: 'right'},
          {id: 'memo', header: '变更备注', field: 'slot:memo', minWidth: '300px'},
        ],
        productTypeOption: ProductEnum.typeOption,
        lessQuantityValidator: (alreadyDeliveryQuantity) => {
          return (quantity) => Number(quantity) >= alreadyDeliveryQuantity;
        },
      }
    },
    computed: {
      totalProductNum() {
        return this.form.items.length;
      },
      currencySymbol() {
        if (this.form.items.length > 0) {
          return this.form.items[0].currencySymbol;
        }
        return '';
      }
    },
    methods: {
      orderQuantityInput(index) {
        const orderQuantity = this.form.items[index].newOrderQuantity;
        if (isMeaningful(orderQuantity)) {
          if (this.RE.pt.test(orderQuantity)) {
            this.setAmount(index);
          } else {
            this.form.items[index].newAmount = '-';
          }
        } else {
          this.form.items[index].newAmount = 0;
        }
      },
      includeTaxPriceInput(index) {
        const includeTaxPrice = this.form.items[index].newIncludeTaxPrice;
        if (isMeaningful(includeTaxPrice)) {
          if (this.RE.pt.test(includeTaxPrice)) {
            this.setAmount(index);
          } else {
            this.form.items[index].newAmount = '-';
          }
        } else {
          this.form.items[index].newAmount = 0;
        }
      },
      setAmount(index) {
        const orderQuantity = this.form.items[index].newOrderQuantity;
        const includeTaxPrice = this.form.items[index].newIncludeTaxPrice;
        this.form.items[index].newAmount = toFixed(Number(orderQuantity) * Number(includeTaxPrice));
      },
      formValidate() {
        return this.$gjFormValidate();
      }
    }
  }
</script>

<style scoped>

</style>
